var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCorrect(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Warstwa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 241 247",
    style: {
      enableBackground: "new 0 0 241 247"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#08B60F;}\n\t.st1{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 122,
    cy: 122,
    r: 117
  }), /*#__PURE__*/React.createElement("g", {
    id: "Check"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M196.27,67.44c-7.59-7.6-20.85-7.6-28.45,0l-66.25,66.25l-25.4-25.4c-7.61-7.61-20.86-7.6-28.45,0 c-7.84,7.84-7.85,20.6,0,28.45l39.62,39.63c3.8,3.8,8.85,5.89,14.23,5.89c5.38,0,10.43-2.09,14.22-5.89l80.48-80.47 c3.8-3.8,5.9-8.86,5.9-14.23S200.07,71.24,196.27,67.44z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCorrect);
export default __webpack_public_path__ + "static/media/correct.9273a0a0ce1436314dd9354ed5282d6f.svg";
export { ForwardRef as ReactComponent };